import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, [width]);

  const mainVariant = {
    hidden: {
      opacity: 0.5
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1,
        type: ' tween'
      }
    }
  };

  const childrenVariant = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <motion.div variants={mainVariant} whileInView="visible" initial="hidden" className="hero">
      {/* <div className="mobileLogo">
        <a href="https://www.landroverusa.com/index.html" target="_blank" rel="noreferrer">
          <img src={rangeRoverLogo} alt="lr logo" />
        </a>
      </div> */}
      <motion.div
        variants={childrenVariant}
        whileInView="visible"
        initial="hidden"
        className="hero__header"
      >
        <h1>Future Astronaut</h1>
      </motion.div>
      <motion.div
        variants={childrenVariant}
        whileInView="visible"
        initial="hidden"
        className="hero__paragraph"
      >
        {width <= 640 ? (
          <p>
            Being an astronaut is a rare vocation. In fact, fewer than 1,000 people have done it.
            And of those, fewer than 100 have been women—with only a handful being mothers. As space
            exploration grows, so does female representation. Join Range Rover for a tour of future
            astronaut Kellie Gerardi’s inspiring journey to space.
          </p>
        ) : (
          <p>
            The astronaut vocation is a rare and coveted one. Many dream of traveling among the
            stars and planets, but fewer than 1,000 people have actually ventured into space. And of
            those astronauts, fewer than 100 have been women—with only a handful being mothers. But
            as space exploration grows, so does female representation. Join Range Rover for a tour
            of future astronaut Kellie Gerardi’s inspiring journey to realms beyond our world,
            preparing for the journey of a lifetime. Here the course of future space exploration
            will be charted by this role model dedicated to discovery.
          </p>
        )}
      </motion.div>
    </motion.div>
  );
};

export default Hero;
